import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import "./App.css";
import store from "./store/store";
import { Provider } from "react-redux";

const root = ReactDOM.createRoot(document.getElementById("root")); // Create a root

root.render(
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>
);
